import { Box, Stack } from '@mui/material';

import { FButtonMenu } from '../../baseV2';
import PageContainer from '../PageContainer';
import { TABBED_PAGE_SHELL_CONTENT_SX } from './styles';

import type { TabbedPageShellProps } from './types';

export default function TabbedPageShell({
  tabOptions,
  tabsAriaLabel,
  errorLabel,
  successLabel,
  header,
  footer,
  children,
}: TabbedPageShellProps) {
  return (
    <PageContainer sx={{ px: 3, pt: 3 }}>
      <Stack spacing={3} sx={{ flexGrow: 1 }}>
        {header}
        <FButtonMenu
          ariaLabel={tabsAriaLabel}
          options={tabOptions}
          errorLabel={errorLabel}
          successLabel={successLabel}
        />
        <Box sx={TABBED_PAGE_SHELL_CONTENT_SX}>{children}</Box>
        {footer}
      </Stack>
    </PageContainer>
  );
}
